<template>
  <div id="center">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <router-link to='/activity'>
        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">创新活动</span>
        </span>
        </router-link>
      </div>
      <!-- 4个主要的数据 -->
<!--      <div class="bottom-data">-->
<!--        <div class="item-box" v-for="(item,index) in numberData" :key="index">-->
<!--          <div class="d-flex">-->
<!--            <dv-digital-flop :config="item.number" style="width:2.5rem;height:.625rem;" />-->
<!--          </div>-->
<!--          <p class="text" style="text-align: center;font-size: 14px;color:#4c9bfd">-->
<!--            <i class="icon-dot" style="color: #ed3f35"></i>-->
<!--            {{item.text}}-->
<!--          </p>-->
<!--        </div>-->
<!--      </div>-->
      <div class="d-flex jc-center" style=" margin-top: 0;clear: both;width: 100%">
        <div id="centerChart" style="width: 75%;height: 2.8rem;padding-top: 0.2rem;float:left;"></div>
          <div class="data float-r">
            <div class="item" v-for="(item,pi) in numberData" :key="pi">
              <h4>{{item.value}}</h4>{{tit[pi]}}
              <span>
                                    <i class="icon-dot" :style="{'color':color[pi]}"></i>
                                    {{item.name}}
                                </span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
let Chart
// import Echart from '@/common/echart'
import sciApi from '@/api/index.js'
export default {
  data() {
    return {
      tag:'',
      option: {},
      Num:{
        '政策直播间':0,
        '创新课堂':0,
        '管理学院':0,
        '易智成果汇':0,
        '易智排行榜':0,
        '易智人才汇':0,
        '易智大咖荟':0,
        '智汇两江':0,
        '渝创渝新':0,
      },
      Tum:{
        '服务人数':0,
        '服务企业':0,
        '活动场次':0,
        },
      color:['#ed3f35','#eacf19','#ed3f35'],
      tit:['人','家','场'],
      activityList:[],
      numberData: []
    };
  },
  watch:{
    setregion:{
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val
      }
    },
    tag:{
      immediate: false,
      deep: true,
      handler(val) {
        console.log(val,'val')
        this.init().then(()=>{
          let tum=[]
          for (let key in this.Tum){
            tum.push({ name:key,
              value:this.Tum[key]})
          }
          this.numberData = tum.slice(0,3)
          let num=[]
          for (let key in this.Num){
            num.push({ name:key,
              value:this.Num[key]})
          }
          this.option.series[0].data=num
          Chart.setOption(JSON.parse(JSON.stringify(this.option)),true);
        })
      }
    }
  },
  created() {

  },
  computed:{
    setregion() {
      // console.log(this.$store.state.region)
      return this.$store.state.region
    }
  },
  mounted() {
    this.tag=''
    this.init().then(()=>{
      let tum=[]
      for (let key in this.Tum){
        tum.push({ name:key,
          value:this.Tum[key]})
      }
      this.numberData = tum.slice(0,3)
      let num=[]
      for (let key in this.Num){
        num.push({ name:key,
          value:this.Num[key]})
      }
      this.option.series[0].data=num
      Chart.setOption(JSON.parse(JSON.stringify(this.option)),true);
    })
    this.option = {
      tooltip: {
        // 触发类型  经过轴触发axis  经过轴触发item
        trigger: 'item',
        // 轴触发提示才有效
        axisPointer: {
          // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果
          type: 'shadow'
        }
      },
      grid: {
        // 距离 上右下左 的距离
        left: '5%',
        bottom:"5%",
        top:'3%',
        // 大小是否包含文本【类似于boxsizing】
        containLabel: true,
        //显示边框
        show: false,
        //边框颜色
        borderColor: 'rgba(0, 240, 255, 0.3)'
      },
      xAxis: {
        // 使用类目，必须有data属性

        // 使用 data 中的数据设为刻度文字
        type: 'category',
        data: [
          "政策直播间",
          "创新课堂",
          "管理学院",
          "易智成果汇",
          "易智排行榜",
          "易智人才汇",
          "易智大咖荟",
          "智汇两江",
          "渝创渝新",
         ],
        // 刻度设置
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false
        },
        axisLine:{
          lineStyle:{
            color:'#4c9bfd',
          },

        },
        //文字
        axisLabel: {
          color: '#4c9bfd',
          interval: 0,
          rotate: 30
        },
        splitLine: {
          show:false,
          lineStyle: {
            color: '#4c9bfd',
            show:true
          }
        }
      },
      yAxis: {
        type: 'value',
        boundaryGap: [0, 0.01],
        // 使用数据的值设为刻度文字

        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false

        }, //坐标线
        axisLine:{
          lineStyle:{
            color:'#4c9bfd'
          }},
        //文字
        axisLabel: {
          color: '#4c9bfd',
          fontSize: '12',
          show:false
        },
        splitLine: {
          show:false,
          lineStyle: {
            color: '#4c9bfd',
            show:true
          }
        },
      },
      series: [{
        barWidth: 15,
        itemStyle: {
          normal: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              // { offset: 0, color: "#956FD4" },
              // { offset: 1, color: "#3EACE5" }
              { offset: 1, color: '#0061ce' }, // 1 结束颜色
              { offset: 0, color: '#00fffb' }  // 0 起始颜色
            ])
          }
        },
        label: {
          show: true,
          position: 'top',
          color:'#4c9bfd',
          // formatter: "{c}场",
        },
        data: [],
        type: 'bar'
      }]
    };
    this.drawLine();
  },
  methods: {
      async init(){
        const that = this;
        await sciApi.selectActivity({pageSize: 1000,pageNum: 1}).then((data)=>{
          // data 就是接口返回值
          this.activityList = data.list || []
          if(this.tag!==''){
            this.activityList.forEach((item) => {
              if(item.mapAreaDisplay == that.tag)
              {
                that.Tum[item.level2Display] += parseInt(item.mapNum);
                that.Num[item.level1Display] += parseInt(item.mapNum);
              }else {
                that.Num[item.level1Display] = 0;
                that.Tum[item.level1Display] = 0;
              }
            })
          }
          else {
            this.activityList.forEach((item) => {
              that.Tum[item.level2Display] += parseInt(item.mapNum);
              that.Num[item.level1Display] += parseInt(item.mapNum);
            })
          }
        })
    },
    drawLine:function (){
      //基于准备好的dom，初始化echarts实例
      Chart = this.$echarts.init(document.getElementById('centerChart'))
      Chart.setOption(this.option);
    },
    setOption(){
      // if(!Chart.clear) return
      // Chart.clear()
      // option && myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss">
#center {
  padding: 0.2rem;
  height:100%;
  width: 100%;
  border-radius: 0.0625rem;
  .bg-color-black {
    //padding: 0.0625rem;
    //height: 100%;
    //border-radius: 0.125rem;
  }
  .data{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 25%;
    box-sizing: border-box;
    background: #142957;
    font-size: 14px;
    height: 2.6rem;
    padding:0.3rem 0;
    color:#5cd9e8;
    border-radius: 0 0.5rem 0 0.5rem;
    .item{
      margin-bottom:0.3rem;
      text-align: center;
    }
    .item h4{
      display: inline-block;
      margin-bottom: 0.1rem;
      font-size:24px;
      color: #fff;
      font-weight: normal;
      margin-right: 5px;
    }
    .item span{
      width: 100%;
      display: block;
      color:#5cd9e8;
    }
  }
  .text {
    color: #c3cbde;
  }
  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;
    .active-ring-name {
      padding-top: 0.125rem;
    }
  }

  .bottom-data {
    .item-box {
      float: left;
      position: relative;
      width: 33%;
      color: #d3d6dd;
      // 金币
      .coin {
        position: absolute;
        left: 0.1rem;
        top: 0.2125rem;
        font-size: 0.25rem;
        color: #ffc107;
      }
      .colorYellow {
        color: yellowgreen;
      }
    }
  }
}
</style>